module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navigation-bar"
  }, [_c('el-menu', {
    attrs: {
      "theme": "dark",
      "default-active": _vm.defaultRoute.name,
      "mode": "horizontal",
      "router": true
    }
  }, [_c('li', {
    staticClass: "brand"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v(_vm._s(_vm.$t('ulockme')))])], 1), _vm._v(" "), _vm._l((_vm.routes), function(route) {
    return [(route.routes) ? _c('el-submenu', {
      attrs: {
        "index": route.name
      }
    }, [_c('template', {
      slot: "title"
    }, [_vm._v(_vm._s(_vm.$t('nav.' + route.name)))]), _vm._v(" "), _vm._l((route.routes), function(route) {
      return _c('el-menu-item', {
        attrs: {
          "route": route,
          "index": route.name
        }
      }, [_vm._v(_vm._s(_vm.$t('nav.' + route.name)))])
    })], 2) : _c('el-menu-item', {
      attrs: {
        "route": route,
        "index": route.name
      }
    }, [_vm._v(_vm._s(_vm.$t('nav.' + route.name)))])]
  }), _vm._v(" "), _c('el-menu-item', {
    staticClass: "right",
    attrs: {
      "index": "logout"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.logout($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('nav.logout')))]), _vm._v(" "), _c('el-submenu', {
    staticClass: "right",
    attrs: {
      "index": "lang"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t('nav.' + 'changeLanguage')))]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "route": _vm.currentRoute,
      "index": _vm.currentRoute.name
    },
    nativeOn: {
      "click": function($event) {
        return _vm.changeLang('hu')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('lang.hungarian')))]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "route": _vm.currentRoute,
      "index": _vm.currentRoute.name
    },
    nativeOn: {
      "click": function($event) {
        return _vm.changeLang('en')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('lang.english')))])], 2)], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3ea7d702!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationBar.vue
// module id = 991
// module chunks = 2